import type { IStatusProps } from 'shared/ui'
import type { ICustomDomainStatus } from 'entities/ShortLink'

export const statusesMap: Record<ICustomDomainStatus, IStatusProps> = {
  pending: {
    title: 'Draft',
    intent: 'neutral',
    emphasis: 'high',
    icon: 'draft',
  },
  draft: {
    title: 'Draft',
    intent: 'neutral',
    emphasis: 'high',
    icon: 'draft',
  },
  certificate_in_progress: {
    title: 'Pending',
    intent: 'informative',
    emphasis: 'high',
    icon: 'clock',
  },
  certificate_processed: {
    title: 'Pending',
    intent: 'informative',
    emphasis: 'high',
    icon: 'clock',
  },
  waiting_for_payment: {
    title: 'Pending Payment',
    intent: 'informative',
    emphasis: 'high',
    icon: 'clock',
  },
  verify_failed: {
    title: 'Verification Failed',
    intent: 'negative',
    emphasis: 'high',
    icon: 'alertCircle',
  },
  payment_failed: {
    title: 'Unsubscribed',
    intent: 'negative',
    emphasis: 'high',
    icon: 'closeCircle',
  },
  unsubscribed: {
    title: 'Unsubscribed',
    intent: 'negative',
    emphasis: 'high',
    icon: 'closeCircle',
  },
  payed: {
    title: 'Active',
    intent: 'positive',
    emphasis: 'high',
    icon: 'check2',
  },
  active: {
    title: 'Active',
    intent: 'positive',
    emphasis: 'high',
    icon: 'check2',
  },
}
